var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.onClicked}},[_c('span',[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }